import { Alert, AlertColor, Snackbar, SnackbarProps } from "@mui/material";

interface SnackAlertProps extends SnackbarProps {
	severity: AlertColor;
}

export default function SnackAlert(props: SnackAlertProps) {
	return (
		<Snackbar {...props}>
			<Alert severity={props.severity}>{props.message}</Alert>
		</Snackbar>
	);
}
